import React, { useState, useEffect } from 'react';
import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { Link } from 'react-router-dom';
import MyComponent from './MyComponent';
import Beats from './screens/Beats';
import Services from './screens/Services';
import ContactMe from './screens/ContactMe';
import Vol1 from './screens/Vol1';
import Vol2 from './screens/Vol2';
import Shop from './screens/Shop';
import Vol3 from './screens/Vol3';
import Vol4 from './screens/Vol4';
import Vol5 from './screens/Vol5';
import Playlists from './screens/Playlists';
import PlaylistView from './screens/PlaylistView';
import VerifyEmail from './screens/VerifyEmail';
import ResetPassword from './screens/ResetPassword';
import { getImageUrl } from './services/r2Service';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { QueueProvider } from './contexts/QueueContext';
import AuthModal from './components/AuthModal';
import QueueDrawer from './components/QueueDrawer';
import QueuePlayer from './components/QueuePlayer';
import { useQueue } from './contexts/QueueContext';
import { FaListUl } from 'react-icons/fa';

const ImagePreloader: React.FC = () => {
  useEffect(() => {
    const imageUrls = [
      getImageUrl('vol1.jpg'),
      getImageUrl('vol2.jpeg'),
      getImageUrl('vol3.jpg'),
      getImageUrl('vol4.png'),
      getImageUrl('Truman Vol 5 Photo.png')
    ];
    imageUrls.forEach(url => {
      const img = new Image();
      img.src = url;
    });
  }, []);
  return null;
};

const NavBar: React.FC = () => {
  const { user, loading, logout } = useAuth();
  const { queue } = useQueue();
  const [authModalOpen, setAuthModalOpen] = useState(false);
  const [queueOpen, setQueueOpen] = useState(false);

  return (
    <>
      <nav className="navbar">
        <Link className="nav-link" to="/">Home</Link>
        <Link className="nav-link" to="/beats">Beat&nbsp;Tapes</Link>
        <Link className="nav-link" to="/services">Services</Link>
        <Link className="nav-link" to="/contact-me">Contact</Link>
        <Link className="nav-link" to="/shop">Shop</Link>
        {user && <Link className="nav-link" to="/playlists">Playlists</Link>}

        <button onClick={() => setQueueOpen(true)} className="nav-link" style={queueBtnStyle}>
          <FaListUl />
          {queue.length > 0 && <span style={badgeStyle}>{queue.length}</span>}
        </button>

        {!loading && (user ? (
          <span className="nav-link" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <span style={{ color: '#b08a8a' }}>{user.displayName}</span>
            <button onClick={logout} style={logoutBtnStyle}>Logout</button>
          </span>
        ) : (
          <button onClick={() => setAuthModalOpen(true)} className="nav-link" style={signInBtnStyle}>
            Sign&nbsp;In
          </button>
        ))}
      </nav>
      <AuthModal isOpen={authModalOpen} onClose={() => setAuthModalOpen(false)} />
      <QueueDrawer isOpen={queueOpen} onClose={() => setQueueOpen(false)} />
    </>
  );
};

const queueBtnStyle: React.CSSProperties = {
  background: 'none', border: 'none', cursor: 'pointer', position: 'relative',
  fontSize: '1rem', padding: '0 10px', display: 'inline-flex', alignItems: 'center',
  color: '#815353',
};

const badgeStyle: React.CSSProperties = {
  position: 'absolute', top: '-6px', right: '2px', background: '#b08a8a',
  color: '#2e2020', borderRadius: '50%', width: '16px', height: '16px',
  fontSize: '0.65rem', display: 'flex', alignItems: 'center', justifyContent: 'center',
  fontWeight: 'bold',
};

const signInBtnStyle: React.CSSProperties = {
  background: 'none', border: '1px solid #b08a8a', borderRadius: '20px',
  padding: '4px 14px', cursor: 'pointer', fontSize: 'inherit', color: '#815353',
};

const logoutBtnStyle: React.CSSProperties = {
  background: 'none', border: '1px solid #815353', borderRadius: '12px',
  padding: '2px 10px', cursor: 'pointer', color: '#815353', fontSize: '0.8rem',
};

const AppContent: React.FC<{ searchTerm: string; setSearchTerm: (v: string) => void }> = ({ searchTerm, setSearchTerm }) => {
  const { isQueueActive } = useQueue();

  return (
    <div>
      <NavBar />
      {isQueueActive ? (
        <QueuePlayer />
      ) : (
        <Routes>
          <Route path="/beats" element={<Beats />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/services" element={<Services />} />
          <Route path="/contact-me" element={<ContactMe />} />
          <Route path="/Vol2" element={<Vol2 searchTerm={searchTerm} setSearchTerm={setSearchTerm} />} />
          <Route path="/Vol3" element={<Vol3 searchTerm={searchTerm} setSearchTerm={setSearchTerm} />} />
          <Route path="/Vol4" element={<Vol4 searchTerm={searchTerm} setSearchTerm={setSearchTerm} />} />
          <Route path="/Vol5" element={<Vol5 searchTerm={searchTerm} setSearchTerm={setSearchTerm} />} />
          <Route path="/playlists" element={<Playlists />} />
          <Route path="/playlists/:id" element={<PlaylistView />} />
          <Route path="/verify" element={<VerifyEmail />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/" element={<MyComponent />} />
          <Route path="/Vol1" element={<Vol1 searchTerm={searchTerm} setSearchTerm={setSearchTerm} />} />
        </Routes>
      )}
    </div>
  );
};

const App: React.FC = () => {
  const [searchTerm, setSearchTerm] = useState('');

  return (
    <Router>
      <AuthProvider>
        <QueueProvider>
          <ImagePreloader />
          <AppContent searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
        </QueueProvider>
      </AuthProvider>
    </Router>
  );
};

export default App;
